<template>
  <template v-if="getSeller.length > 0">
    <div :key="seller.email" v-for="seller in getSeller" class="your-seller">
      <img :src="seller.image" alt="Seller image" />
      <div class="seller-information">
        <p class="normal">{{ seller.name }}</p>
        <p>{{ seller.title }}</p>
        <a
          :id="seller.name"
          :href="`tel:${seller.phone}`"
          class="phone-icon plausible-event-name=Puhelinsoitto"
          ><span>{{ seller.phone }}</span></a
        >
        <a
          class="mail-icon plausible-event-name=Sahkoposti"
          :href="`mailto:${seller.email}`"
          v-html="getFormattedEmail(seller.email)"
        ></a>
      </div>
    </div>
  </template>
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "YourSeller",
  computed: {
    ...mapGetters(["getSeller"]),
    ...mapState(["is_industry"]),
  },
  methods: {
    getFormattedEmail: function (email) {
      if (email)
        return `<span>${email.split("@").reduce((acc, currentValue, index) => {
          if (index === 0) return acc + currentValue + "<wbr>@";
          return acc + currentValue;
        }, "")}</span>`;
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.your-seller {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 1rem 2rem;
  img {
    width: 175px;
    height: 175px;
    @media screen and (max-width: 768px) {
      width: 100px;
      height: 100px;
    }
    border-radius: 50%;
    object-fit: cover;
    object-position: center;
  }

  .seller-information {
    display: flex;
    flex-direction: column;
    justify-content: center;
    white-space: normal;
    p {
      margin: 0 0 0.25rem;
      font-size: 20px;
      font-weight: lighter;

      &.normal {
        margin-bottom: 1rem;
        font-weight: 500;
      }
    }
    a {
      font-size: 20px;
      font-weight: 500;
      &.phone-icon,
      &.mail-icon {
        display: flex;
        gap: 0 0.5rem;
        text-decoration: none;

        &::before {
          font-family: "Font Awesome 6 Pro";
          font-weight: 300;
          text-decoration: none;
          display: inline-block;
          color: var(--bs-dark);
        }
      }
      &.phone-icon::before {
        content: "\f095";
      }
      &.mail-icon::before {
        content: "\f0e0";
      }
    }
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 120px 1fr;
    gap: 1rem 1rem;
    img {
      width: 120px;
      height: 120px;
    }
  }
  @media screen and (max-width: 568px) {
    grid-template-columns: 100px 1fr;

    img {
      width: 100px;
      height: 100px;
    }
    .seller-information {
      p,
      a {
        font-size: 16px;
      }
      p.normal {
        margin-bottom: 0.5rem;
      }
    }
  }
}
</style>
<style lang="scss">
// Hack since the span in email is added in post.
.seller-information a {
  &.phone-icon,
  &.mail-icon {
    span {
      text-decoration: underline;
    }
  }
}
</style>
